import styles from "../PostJob.module.scss";
import {CrossButtonBlack} from "components/Buttons/CrossButton";
import clsx from "clsx";
import React from "react";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";

export const ErrorModal = ({message, title = 'Cannot Post Job', onCloseButtonClick}: { message: string, title?: string, onCloseButtonClick: (e: any) => void }) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>{title}</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                {message}
            </div>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
                className={clsx(styles.okButton)}
            >
                OK
            </StyledButton>
        </>
    );
}